import { createFeatureSelector, createSelector } from '@ngrx/store';
import { List } from 'immutable';
import { handleActions } from 'redux-actions';
import { AccountMigration } from './models/account-migration.model';
import {
  ActionsEnum,
  SetCompletedOnboardingData,
  UpdateAccountMigration,
} from './onboarding-data.actions';

// feature name
export const FEATURE_NAME = 'onboarding-data';

// state definition
export interface IState {
  accountMigration: AccountMigration;
  completedOnboardingData: List<string>;
}

// initial state
export const initialState: IState = {
  accountMigration: void 0,
  completedOnboardingData: List<string>(),
};

// reducer
const reducerFn = handleActions(
  {
    [ActionsEnum.UPDATE_ACCOUNT_MIGRATION]: function (
      state: IState,
      { payload }: UpdateAccountMigration
    ): IState {
      return {
        ...state,
        accountMigration: payload.accountMigration,
      };
    },
    [ActionsEnum.FETCH_ACCOUNT_MIGRATION_ERROR]: function (
      state: IState
    ): IState {
      return {
        ...state,
        accountMigration: state.accountMigration || null,
      };
    },
    [ActionsEnum.SET_COMPLETED_ONBOARDING_DATA]: function (
      state: IState,
      { payload }: SetCompletedOnboardingData
    ): IState {
      return {
        ...state,
        completedOnboardingData: payload.accountUserIds,
      };
    },
  } as any,
  initialState
);

// required for AOT
export function reducer(state: IState = initialState, action: any) {
  return reducerFn(state, action);
}

// selector
const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);

export const getAccountMigration = createSelector(
  selectFeature,
  (state: IState) => state.accountMigration
);

export const getCompletedOnboardingData = createSelector(
  selectFeature,
  (state: IState) => state.completedOnboardingData
);
